// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"c6a738b3","56":"bfdd3591","64":"3a6cdb15","355":"9b5356ea","418":"aac0f535","513":"a68ad30e","596":"9d55b28e","675":"3ac25930","756":"54d401b8","784":"18961f81","821":"9e20e9cf","910":"59c9ee58","923":"1edf40c1","925":"e2f49d35"}[chunkId] + ".chunk.css";
};